import { SxProps, Theme } from "@mui/material";
import { FC } from "react";

import { useFrontendAuctionContext } from "@/common/contexts/FrontendAuctionContext";
import { FormWelcomeBanner } from "@/forms-design-system/FormWelcomeBanner/FormWelcomeBanner";

interface AuctionWelcomeBackBannerProps {
  sx?: SxProps<Theme>;
}

export const AuctionWelcomeBackBanner: FC<AuctionWelcomeBackBannerProps> = ({ sx }) => {
  const { isReturningBidder, existingCommand } = useFrontendAuctionContext();

  if (!isReturningBidder || !existingCommand?.firstName) {
    return null;
  }

  return <FormWelcomeBanner memberName={existingCommand.firstName} sx={sx} />;
};
